export interface ResetStandardsForFormDefinitionsActionType {
  type: '@formDefinitions/RESET_STANDARDS';
}

export const resetStandardsForFormDefinitions = (): ResetStandardsForFormDefinitionsActionType => ({
  type: '@formDefinitions/RESET_STANDARDS',
});
